import { Box } from '@firsttable/web-components/atoms';
import React from 'react';
import Favourite, { type FavouriteProps } from '@/components/organisms/Favourite/Favourite';

export type FavouriteWrapperProps = {
  restaurant: FavouriteProps['restaurant'];
  children: React.ReactNode;
};

const FavouriteWrapper = ({ restaurant, children }: FavouriteWrapperProps) => (
  <Box position="relative" width="100%" height="100%">
    {restaurant?.id && <Favourite restaurant={restaurant} className="absolute left-3 top-3 z-20" />}
    {children}
  </Box>
);

export default FavouriteWrapper;
